/* Hook encargado del Cliente

Autor: Carolina Rojas
Fecha: 
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'
import Client from '../interfaces/Client.ts'

import { makeUrlClientEdit } from './connectionData.tsx'

const useClientPoster = () => {
  const [errorPostClient, setErrorPostClient] = useState<string | null>(null)
  const [loadingPost, setLoadingPost] = useState<boolean>(false)

  const postClient = async (client: Client) => {
    setLoadingPost(true)

    try {
      const apiUrl = makeUrlClientEdit()

      console.log('URL:', apiUrl)
      console.log('Payload being sent:', client)

      const res = await customPost<{ _id: string }>(apiUrl, client)

      console.log('Response from API:', res)

      setErrorPostClient(null)

      return res._id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPostClient(err.message)
      } else {
        setErrorPostClient('An unknown error occurred')
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorPostClient, loadingPost, postClient }
}
export default useClientPoster
